export const removeStyle = ({ commit }) => {
    commit('removeStyle');
  };

  export const addStyle = ({ commit }) => {
    commit('addStyle');
  };

  export const changeRouterID=({commit},prop) =>{
    commit('changeRouterID',prop)
  }
  
  export const showBlackmask=({commit}) =>{
    commit('showBlackmask');
  }

  export const removeBlackmask=({commit}) =>{
    commit('removeBlackmask')
  }

  export const getDropDom=({commit},prop) =>{
    commit('getDropDom',prop)
  }

  export const getUserID=({commit},prop) =>{
    commit('getUserID',prop)
  }

  export const getUserName=({commit},prop)=>{
    commit('getUserName',prop)
}

export const getUserAvatar=({commit},prop)=>{
    commit('getUserAvatar',prop)
}
